module.exports = __webpack_public_path__ + "static/media/1_A1_15.f25d2ec2.png";